<div class="w-full h-full flex flex-col py-6 px-6 overflow-y-auto">
    <!-- Actions -->
    <div class="flex justify-end items-center dark:text-gray-300 text-sm">
        <div class="flex items-center flex-wrap gap-2 mr-2">
            <input type="checkbox" class="w-5 h-5 dark-checkbox" [(ngModel)]="include_last_login">
            <p class="text-white">Include Last Login Data</p>
        </div>
        <button type="button" class="ml-2 dark-btn min-w-[125px]" (click)="clear_filters()">
            <i class="fa-solid fa-xmark mr-1 dark:text-green-600"></i> Clear Filters
        </button>
        <button type="button" class="ml-2 dark-btn min-w-[105px]" (click)="get_theotrade_billing(false)">
            <i class="fa-solid fa-magnifying-glass mr-1 dark:text-green-600"></i> Get Report
        </button>
        <button type="button" class="ml-2 dark-btn min-w-[105px]" (click)="get_theotrade_billing(true)">
            <i class="fa-solid fa-fw fa-sync mr-1 dark:text-green-600"></i> Refresh Data
        </button>
    </div>


    <!-- Revenue Summary -->
    <div class="flex items-center gap-3 mt-3 mb-3">
        <h2 class="text-2xl text-white font-bold">Revenue Summary</h2>
        <button type="button" (click)="download_csv(revenue_rows, 'theotrade-revenue-summary')" *ngIf="revenue_rows.length > 0" class="ml-2 dark-btn min-w-[105px] text-sm">
            <i class="fa-solid fa-download mr-1 dark:text-green-600"></i> Export CSV
        </button>
    </div>
    <div class="w-full overflow-x-auto pb-1 min-h-[235px]">
        <table class="billing-report w-full text-white">
            <thead>
                <tr class="customer-row">
                    <th class="left text-lg font-semibold">Scanner</th>
                    <th class="text-sm font-semibold min-w-[160px]" *ngFor="let month of revenue_month_keys">
                        {{ format_month(month) }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of revenue_rows">
                <td class="left scanner text-sm">{{ row.scanner }}</td>

                <td class="text-sm" *ngFor="let month of revenue_month_keys">
                    {{ row[month] }}
                </td>
                </tr>
            </tbody>
        </table>
    </div>


    <!-- Lifetime Members -->
    <div class="flex items-center gap-3 mt-10 mb-3">
        <h2 class="text-2xl text-white font-bold">Legacy Users</h2>
    </div>
    <div class="w-full overflow-x-auto pb-1 min-h-[235px]">
        <table class="billing-report w-full text-white">
            <thead>
                <tr class="customer-row">
                    <th class="left text-lg font-semibold">Scanner</th>
                    <th class="text-sm font-semibold min-w-[100px]" *ngFor="let month of user_month_keys">
                        {{ format_month(month) }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of legacy_user_rows">
                <td class="left scanner text-sm">{{ row.scanner }}</td>

                <td class="text-sm" *ngFor="let month of user_month_keys">
                    {{ row[month] }}
                </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Lifetime Members -->
    <div class="flex items-center gap-3 mt-10 mb-3">
        <h2 class="text-2xl text-white font-bold">Phantom Users (No Order History)</h2>
        <button type="button" (click)="download_csv(missing_order_logs, 'theotrade-missing-order-history')" *ngIf="missing_order_logs.length > 0" class="ml-2 dark-btn min-w-[105px] text-sm">
            <i class="fa-solid fa-download mr-1 dark:text-green-600"></i> Export CSV
        </button>
    </div>
    <div class="w-full overflow-x-auto pb-1 min-h-[235px]">
        <table class="billing-report w-full text-white">
            <thead>
                <tr class="customer-row">
                    <th class="left text-lg font-semibold">Scanner</th>
                    <th class="text-sm font-semibold min-w-[100px]" *ngFor="let month of user_month_keys">
                        {{ format_month(month) }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of ghost_user_rows">
                <td class="left scanner text-sm">{{ row.scanner }}</td>

                <td class="text-sm" *ngFor="let month of user_month_keys">
                    {{ row[month] }}
                </td>
                </tr>
            </tbody>
        </table>
    </div>


    <!-- Order History Grid -->
    <div class="flex items-center gap-3 mt-6 mb-3">
        <h2 class="text-2xl text-white font-bold">Order History</h2>
        <button type="button" (click)="download_csv(data, 'theotrade-order-history')" *ngIf="data.length > 0" class="ml-2 dark-btn min-w-[105px] text-sm">
            <i class="fa-solid fa-download mr-1 dark:text-green-600"></i> Export CSV
        </button>
    </div>
    <div class="h-[500px]">
        <ag-grid-angular
        class="flex-1 w-full h-[500px]"
        [theme]="theme"
        [gridOptions]="grid.options"
        [columnDefs]="grid.columnDefs"
        [rowData]="data"
        [statusBar]="grid.statusBar"
        (gridReady)="on_grid_ready($event)"
        (modelUpdated)="on_model_updated($event)"
        (rowSelected)="on_row_selected($event)"
        />
    </div>


    <!-- User Tracking Grid -->
    <div class="flex items-center gap-3 mt-12 mb-3">
        <h2 class="text-2xl text-white font-bold">User Tracking</h2>
        <button type="button" (click)="download_csv(tracking_data, 'theotrade-user-tracking')" *ngIf="tracking_data.length > 0" class="ml-2 dark-btn min-w-[105px] text-sm">
            <i class="fa-solid fa-download mr-1 dark:text-green-600"></i> Export CSV
        </button>
    </div>
    <div class="h-[500px] mb-10">
        <ag-grid-angular
        class="flex-1 w-full h-[500px]"
        [theme]="theme"
        [gridOptions]="tracking_grid.options"
        [columnDefs]="tracking_grid.columnDefs"
        [rowData]="tracking_data"
        [statusBar]="tracking_grid.statusBar"
        (gridReady)="on_tracking_grid_ready($event)"
        (modelUpdated)="on_tracking_model_updated($event)"
        (rowSelected)="on_tracking_row_selected($event)"
        />
    </div>
</div>